var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFAC06",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 25C22.9167 26.6108 21.6108 27.9167 20 27.9167C18.3892 27.9167 17.0833 26.6108 17.0833 25",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0259 24.9997H13.9741C13.16 24.9997 12.5 24.3397 12.5 23.5256C12.5 23.1347 12.6553 22.7598 12.9317 22.4833L13.4344 21.9806C13.9033 21.5118 14.1667 20.8758 14.1667 20.2128V17.9163C14.1667 14.6947 16.7783 12.083 20 12.083C23.2217 12.083 25.8333 14.6947 25.8333 17.9163V20.2128C25.8333 20.8758 26.0967 21.5118 26.5656 21.9806L27.0682 22.4833C27.3447 22.7598 27.5 23.1347 27.5 23.5256C27.5 24.3397 26.84 24.9997 26.0259 24.9997Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.5a5164cf00ed85f31c7cba33f0fa51d0.svg";
export { ForwardRef as ReactComponent };